// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__YjdJz","head__title":"styles_head__title__j51Pe"};